import { MessageFactory } from "@pages/Article/components/ArticleSubshare/helpers";
import { LambdaResponsePayload } from "@pages/Article/types/Alacrity";

export type MessagesProps = LambdaResponsePayload;

export default function Messages({
  data: { responseType },
}: MessagesProps): React.ReactElement {
  const Message = MessageFactory(responseType);

  // Needs to pull the amount gift left from Alacrity API.
  return <>{Message ? <Message giftLeft={1} /> : null}</>;
}
